import { Loader, Paper, Stack, Text } from "@mantine/core";

export const DrofusChangesLoadingOverlay: React.FC = () => (
  <Paper withBorder shadow="sm" radius="sm" p="lg" role="status" aria-live="polite">
    <Stack align="center" gap="xs">
      <Loader size="sm" aria-hidden="true" />
      <Text size="sm">Laster endringer…</Text>
    </Stack>
  </Paper>
);
